import { Injectable, isDevMode } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class Client {
  getAllTariffs(obj) {
    return 'operator/requests/product' + this.transformObjToGetParameter(obj);
  }

  getDefault() {
    return 'operator/api/838';
  }

  getWs() {
    return 'ws/operator?access_token=';
  }

  getExtraDictionary() {
    return 'dictionary/api';
  } // extra

  getLoginUrl() {
    return 'operator/login';
  }

  getAddressQueryUrl() {
    return 'operator/address/search/';
  }

  deletePassengerAddress() {
    return 'operator/passenger-addresses/rank';
  }

  getTranslateUrl() {
    return 'ui/translations?lang=';
  }

  getUploadImgUrl() {
    return 'upload';
  }

  getImagesUrl(id) {
    return `images/id/${id}`;
  }

  getCabsMapUrl() {
    return 'operator/maps/hot/cabs';
  }

  getCabsQuery(obj) {
    return 'operator/cab/query' + this.transformObjToGetParameter(obj);
  }

  getOrdersMapUrl() {
    return 'operator/maps/hot/requests';
  }

  getAchiveOrdersUrl() {
    return 'operator/requests/archive';
  }

  getCabsUrl(obj) {
    return 'operator/driver' + this.transformObjToGetParameter(obj);
  }

  getServicesUrl() {
    return 'operator/accessible/services';
  }

  getAllServicesUrl() {
    return '/operator/services';
  }

  getTimezonesUrl() {
    return '/operator/services/timezones';
  }

  getProductsUrl() {
    return 'operator/products/list';
  }

  getTelephonyUrl() {
    return 'operator/telephony/queues';
  }

  getSettingsUrl() {
    return 'operator/settings';
  }

  getNotificationsSettingsUrl() {
    return 'operator/settings/notification';
  }

  getNotificationsGatesUrl() {
    return 'operator/settings/gates';
  }

  getFaresUrl() {
    return 'operator/products';
  }

  getProductsList() {
    return 'operator/passenger-app/settings';
  }

  getEstimateCountPriceUrl() {
    return /*'operator/requests/estimate'*/ environment.config.estimate;
  }

  getOrderExtendUrl() {
    return '/operator/requests/extend';
  }

  getPassengerUrl() {
    return 'operator/passenger';
  }

  getOrderCabRequest(obj) {
    return 'operator/requests/show' + this.transformObjToGetParameter(obj);
  } // id - > request id

  getRemoveOrderUrl(obj) {
    return 'operator/requests/reasons' + this.transformObjToGetParameter(obj);
  } // ?id=

  getRemoveOrderCabUrl(obj) {
    return 'operator/trips/reasons' + this.transformObjToGetParameter(obj);
  } // ?id=

  getTripCloseReasons() {
    return 'operator/trips/close-reasons';
  }

  getOrderSaveUrl() {
    return 'operator/requests/store';
  }

  getOrderCancelUrl() {
    return 'operator/requests/cancel';
  }

  getOrderUpdateUrl() {
    return 'operator/requests/update';
  }

  getOrderAssignCabUrl() {
    return 'operator/requests/reserve';
  }

  getOrderHoldUrl() {
    return 'operator/requests/hold';
  } // order_id

  getFareUrl(obj?) {
    return 'operator/requests/fare' + this.transformObjToGetParameter(obj);
  }

  // getFare2Url() { return 'operator/requests/fare' }

  getOrderUnholdUrl() {
    return 'operator/requests/unhold';
  } // order_id

  getImgsUrl() {
    return 'imgs/';
  }

  getTariffPlanListUrl(obj) {
    return 'operator/tariff-plans' + this.transformObjToGetParameter(obj);
  }

  // Users service

  getUsersUrl(obj?) {
    return 'operator/users' + this.transformObjToGetParameter(obj);
  }

  getUsersServiceUrl(obj?) {
    return 'operator/accesses/user/services' + this.transformObjToGetParameter(obj);
  }

  getUserRolesUrl(obj?) {
    return 'operator/users/roles' + this.transformObjToGetParameter(obj);
  }

  getRolesUrl() {
    return 'operator/roles';
  }

  getUserListUrl() {
    return `operator/users`;
  }

  // Common service

  getMenuUrl() {
    return 'operator/menu';
  }

  getFeaturesUrl(obj) {
    return 'operator/features' + this.transformObjToGetParameter(obj);
  } // ?service=838

  getAllFeaturesUrl(obj) {
    return 'operator/features/all' + this.transformObjToGetParameter(obj);
  }

  getFeaturesUpdateUrl() {
    return 'operator/features';
  }

  getUserPermisionUrl() {
    return 'operator/accessible/permissions';
  }

  getWhoamiUrl(): string {
    return 'operator/whoami';
  }

  getAssignUrl() {
    return '/operator/driver/vehicle/assign';
  } // put service id vehicle_id driver
  // <-> vehicle
  getDeasignUrl() {
    return '/operator/driver/vehicle/deassign';
  } // put service id vehicle_id
  // driver <-> vehicle
  //  dictionary service

  getColorUrl() {
    return 'operator/dictionary/colors';
  }

  getCountryUrl() {
    return 'operator/dictionary/countries';
  }

  getDocumentTypesUrl() {
    return 'operator/dictionary/document-types';
  }

  getVehicleBodyTypesUrl() {
    return 'operator/dictionary/vehicle-body-types';
  }

  getVehicleBrandsUrl() {
    return 'operator/dictionary/vehicle-brands';
  }

  getVehicleModelUrl(obj) {
    return 'operator/dictionary/vehicle-models' + this.transformObjToGetParameter(obj);
  }

  getVehicleBrandUrl() {
    return 'operator/dictionary/vehicle-model';
  }

  getVehicleCategoriesUrl() {
    return 'operator/dictionary/vehicle-categories';
  }

  getDriverFiredReasonsUrl(obj) {
    return 'operator/dictionary/driver-fired-reasons' + this.transformObjToGetParameter(obj);
  }

  getDriverStatusesUrl(obj) {
    return 'operator/dictionary/driver-statuses' + this.transformObjToGetParameter(obj);
  }

  //  driver service

  getDriverReplenishUrl() {
    return 'operator/accounting/add';
  }

  getDriverMinusUrl() {
    return 'operator/accounting/sub';
  }

  getDriverBlockUrl() {
    return 'operator/driver/block';
  }

  getDriverUnblockUrl() {
    return 'operator/driver/unblock';
  }

  getDriverSentCodeUrl() {
    return 'operator/driver/account/send';
  }

  getDriverPinUrl() {
    return 'operator/driver/account/pin';
  }

  getDriversUrl() {
    return 'operator/driver';
  }

  getDriversSearchUrl(obj) {
    return 'operator/driver/all' + this.transformObjToGetParameter(obj);
  }

  getDriverUrl(obj) {
    return 'operator/driver/show' + this.transformObjToGetParameter(obj);
  }

  getDriverCarsUrl(obj) {
    return 'operator/driver/vehicles' + this.transformObjToGetParameter(obj);
  }

  // getDriverBlockReasonUrl(obj) { return 'operator/driver/blocking/reason' + this.transformObjToGetParameter(obj); }

  getDriverCreateUrl() {
    return 'operator/driver/create';
  }

  getDriverUpdateUrl() {
    return 'operator/driver/update';
  }

  getDriverFireUrl() {
    return 'operator/driver/fire';
  }

  //  vehicle service

  getVehicleDeleteUrl(obj) {
    return 'operator/vehicle' + this.transformObjToGetParameter(obj);
  } // service,
  // id

  getVehicleDriversUrl(obj) {
    return 'operator/vehicle/drivers' + this.transformObjToGetParameter(obj);
  }

  getVehicleGroupsUrl(obj) {
    return 'operator/vehicle/groups' + this.transformObjToGetParameter(obj);
  }

  getVehicleGroupCountUrl(obj) {
    return 'operator/vehicle/groups/count' + this.transformObjToGetParameter(obj);
  }

  moveVehicleGroupUrl(service_id) {
    return 'operator/vehicle/groups/move?service_id=' + service_id;
  }

  updateVehicleGroupUrl() {
    return 'operator/vehicle/groups';
  }

  createVehicleGroupUrl(service_id) {
    return 'operator/vehicle/groups?service_id=' + service_id;
  }

  getVehicleClassesUrl() {
    return 'operator/vehicle/classes';
  }

  getVehiclesUrl() {
    return 'operator/vehicle';
  }

  getVehicleUrl(obj) {
    return 'operator/vehicle/show' + this.transformObjToGetParameter(obj);
  }

  getVehicleCreateUrl() {
    return 'operator/vehicle/create';
  }

  VehicleUpdateUrl() {
    return 'operator/vehicle/update';
  }

  // vihicle-manager service

  getLogistVehiclesUrl(obj) {
    return 'operator/logistic' + this.transformObjToGetParameter(obj);
  }

  getAllBudgetVehiclesUrl(obj) {
    return 'operator/logistic/all' + this.transformObjToGetParameter(obj);
  }

  getAllLogistCabsUrl(obj) {
    return 'operator/logistic/cabs' + this.transformObjToGetParameter(obj);
  }

  getLogistManipulationVehicleUrl() {
    return 'operator/logistic';
  }

  getMessageUrl() {
    return 'operator/messages/bulk/send';
  }

  getMessageToAllUrl() {
    return 'operator/messages/all/send';
  }

  getTimezoneUrl(service) {
    return 'operator/services/timezone?service_id=' + service;
  }

  // tariff-plans

  getTariffPlansListAdvanced(obj) {
    return 'operator/tariff-plans/advanced' + this.transformObjToGetParameter(obj);
  }

  getTariffPlansUrl(obj?) {
    return 'operator/tariff-plans' + this.transformObjToGetParameter(obj);
  }

  // tariff-plans commissions

  getTariffPlansCommissionsUrl() {
    return 'operator/tariff-plans/commissions';
  }

  // Regular payments

  getRegularPaymentsUrl() {
    return 'operator/tariff-plans/payments';
  }

  getScalesUrl() {
    return 'operator/tariff-plans/payments/scales';
  }

  //  Scheduled Bonuses
  getScheduledBonusesUrl(obj?) {
    return 'operator/scheduled-bonuses' + this.transformObjToGetParameter(obj);
  }

  // Blocking

  getBlockReasonsUrl = obj => {
    return 'operator/blocking/reasons' + this.transformObjToGetParameter(obj);
  };

  getDriverStatusUrl(obj) {
    return 'operator/driver/status' + this.transformObjToGetParameter(obj);
  }

  getBlockHistoryUrl = obj => {
    return 'operator/blocking/history/driver' + this.transformObjToGetParameter(obj);
  };
  // Phone reports
  getAllPhoneReports(obj?) {
    return 'api/admin-call-way-report/list-reports' + this.transformObjToGetParameter(obj);
  }
  getPhoneReportsByPeriod(obj?) {
    return 'api/admin-call-way-report/by-period' + this.transformObjToGetParameter(obj);
  }
  getStartTestPortsUrl() {
    return 'api/admin-call-way-report/start';
  }
  getStopTestPortsUrl() {
    return 'api/admin-call-way-report/stop';
  }
  getPortTestStatus() {
    return 'api/admin-call-way-report/session-is-started';
  }
  getMinDateOfReportsUrl() {
    return 'api/admin-call-way-report/session-min-date';
  }

  // Assigned order instead driver
  acceptOrderInsteadDriver() {
    return 'operator/offer/accept';
  }
  rejectOrderInsteadDriver() {
    return 'operator/offer/reject';
  }

  // Order control
  getTripArrivedUrl() {
    return '/operator/trips/arrived';
  }
  getTripPickupUrl() {
    return '/operator/trips/pickup';
  }
  getTripCompleteUrl() {
    return '/operator/trips/complete';
  }
  getTripCancelUrl() {
    return '/operator/trips/cancel';
  }

  // History service

  getHistoryOrderUrl(obj) {
    return 'operator/history/request' + this.transformObjToGetParameter(obj);
  } // id
  getHistoryDriverUrl(obj) {
    return 'operator/history/driver' + this.transformObjToGetParameter(obj);
  } // id
  getHistoryCauserUrl(obj) {
    return 'operator/history/causer' + this.transformObjToGetParameter(obj);
  } // id = log_id

  // Sheduled Products
  getSheduledProductsUrl(obj?) {
    return 'operator/scheduled-products' + this.transformObjToGetParameter(obj);
  }

  getRoutingMachineRouteUrl(coordinates) {
    return `${environment.config.routingMachine}/route/v1/driving/${coordinates}`;
  }

  getRoutingMachineTableUrl(coordinates, indexes) {
    return `${environment.config.routingMachine}/table/v1/driving/${coordinates}?sources=0&destinations=${indexes}&annotations=distance`;
  }

  getTileUrl() {
    return environment.config.tileServer;
  }

  // passanger-bonuses
  getPassengerBonusesListUrl(): string {
    return `operator/passenger-bonuses`;
  }

  private transformObjToGetParameter(obj) {
    if (!obj) {
      return '';
    }
    let keys = Object.keys(obj);
    let resp = '';
    if (keys.length > 0) {
      for (let i = 0; i < keys.length; i++) {
        if (!i) {
          resp += '?' + keys[i] + '=' + obj[keys[i]];
        } else {
          resp += '&' + keys[i] + '=' + obj[keys[i]];
        }
      }
    }
    return resp;
  }
}

// GET /operator/requests/show?id=REQUEST_ID TODO надо сделать запрос

// GET /operator/passenger?id=841fb5e7-887c-4a68-b074-1c95942a0e94
// driver_sent_cod - post message
// estimateCountPrice - temporary way instead ws estimate

// POST /operator/driver/block
// POST /operator/driver/unblock



// WEBPACK FOOTER //
// ./src/app/shared/services/client.ts